import React, { useState, useEffect } from 'react';
import moment from 'moment';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const CountdownTimer = ({ 
  targetDate, 
  showIcon = true, 
  fontSize = 3, 
  countUp = false,
  expiredText = 'Time expired' 
}) => {
  const [timeText, setTimeText] = useState('');

  // Map fontSize (1-5) to typography variants
  const getFontVariant = () => {
    switch (fontSize) {
      case 1: return 'body2';
      case 2: return 'body1';
      case 3: return 'h6';
      case 4: return 'h5';
      case 5: return 'h4';
      default: return 'h6';
    }
  };

  useEffect(() => {
    const calculateTime = () => {
      const now = moment();
      const target = moment(targetDate);
      
      // Handle countdown vs countup modes
      let duration;
      if (countUp) {
        duration = moment.duration(now.diff(target));
        if (duration.asSeconds() <= 0) {
          return 'Not started yet';
        }
      } else {
        duration = moment.duration(target.diff(now));
        if (duration.asSeconds() <= 0) {
          return expiredText;
        }
      }

      const days = Math.floor(duration.asDays());
      const hours = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();

      return days > 0 
        ? `${days}d:${hours}h:${minutes}m:${seconds}s` 
        : `${hours}h:${minutes}m:${seconds}s`;
    };

    setTimeText(calculateTime());
    
    const timer = setInterval(() => {
      setTimeText(calculateTime());
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate, countUp, expiredText]);

  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center',
      justifyContent: 'flex-start', 
      gap: 1
    }}>
      {showIcon && (
        <Box sx={{
          bgcolor: 'primary.light',
          borderRadius: '50%',
          width: 40,
          height: 40,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          {countUp ? 
            <AccessTimeIcon sx={{ color: 'white', fontSize: 24 }} /> :
            <HourglassTopIcon sx={{ color: 'white', fontSize: 24 }} />
          }
        </Box>
      )}
      <Typography variant={getFontVariant()} color="primary.main">
        {timeText}
      </Typography>
    </Box>
  );
};

export default CountdownTimer; 